import { useState } from "react";

const useOverview = () => {
    const [contractView, setContractView] = useState<'all' | 'readyToSend' | 'fundraisingLink'>('all');
    const [selectedInstitutionId, setSelectedInstitutionId] = useState<number>(0);
    const [selectedVehicleId, setSelectedVehicleId] = useState<number | null>(null);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  
  return {
    contractView,
    setContractView,
    selectedInstitutionId,
    setSelectedInstitutionId,
    selectedVehicleId,
    setSelectedVehicleId,
    isSidebarCollapsed,
    setIsSidebarCollapsed
  }
}

export default useOverview
